<template>
    <div class="download-panel">
        <custom-panel :title="title" :height="height" @moreClick="moreClickHandle">
            <template #content>
                <div class="download-list" v-if="downloadList.length > 0">
                    <div class="download-item" v-for="item in downloadList" :key="item.fileId">
                        <div :class="['icon', getIconClass(item.fileType)]"></div>
                        <div class="main">
                            <div class="title" :title="item.fileName">{{ item.fileName }}</div>
                            <div class="other">{{ item.fileType }} | {{ item.fileSize }}</div>
                        </div>
                        <div class="download" title="下载" @click="downloadFile(item)"></div>
                    </div>
                </div>
                <a-empty style="margin-top: 28px" v-else />
            </template>
        </custom-panel>
    </div>
</template>

<script>
import CustomPanel from '@/components/custom-panel.vue';
import { queryDownloadList, queryFileDetail } from '@/common/api';
import axios from 'axios';

export default {
    props: {
        height: {
            type: Number
        }
    },

    components: {
        CustomPanel
    },

    data() {
        return {
            title: '相关下载',
            downloadList: [],
            extMap: {
                word: ['doc', 'docx', 'txt', 'rtf'],
                exec: ['xls', 'xlsx', 'csv'],
                pptx: ['ppt', 'pptx'],
                pdf: ['pdf'],
                img: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg']
            }
        };
    },

    mounted() {
        this.getDownloadList();
    },

    methods: {
        getIconClass(ext) {
            for (const [type, extensions] of Object.entries(this.extMap)) {
                if (extensions.includes(ext.toLowerCase())) {
                    return type;
                }
            }

            return 'file';
        },

        moreClickHandle() {
            this.$router.push('/download');
        },

        async getDownloadList() {
            try {
                const { data } = await queryDownloadList();
                if (data) {
                    this.downloadList = data.slice(0, 4);
                }
            } catch (error) {
                this.downloadList = [];
            }
        },

        async downloadFile(file) {
            if (file.fileId) {
                try {
                    const { data } = await queryFileDetail(file.fileId);
                    if (data && data.downloadUrl && data.name) {
                        // 去掉文件类型后缀
                        this.downloadByBlob(data.downloadUrl, data.name);
                    }
                } catch (error) {
                    console.error('获取文件详情失败:', error);
                }
            }
        },

        downloadByBlob(url, fileName) {
            axios.get(url, { responseType: 'blob' }).then(res => {
                const blob = new Blob([res.data]);
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = fileName ?? true;
                link.click();
                URL.revokeObjectURL(link.href);
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.download-panel {
    .download-list {
        display: flex;
        flex-flow: row wrap;
        gap: 16px;

        .download-item {
            width: calc((100% - 16px) / 2);
            height: 90px;
            padding: 12px;
            border-radius: 4px;
            background: #f0f4fb;
            border: 1px solid #dfe8f8;
            display: flex;
            align-items: center;

            &:hover {
                border: 1px solid #b6c6eb;
            }

            .icon {
                width: 46px;
                height: 46px;
                background: url(../imgs/icon-file.svg) no-repeat center center;

                &.exec {
                    background: url(../imgs/icon-excel.svg) no-repeat center center;
                }

                &.word {
                    background: url(../imgs/icon-word.svg) no-repeat center center;
                }

                &.pptx {
                    background: url(../imgs/icon-ppt.svg) no-repeat center center;
                }

                &.pdf {
                    background: url(../imgs/icon-pdf.svg) no-repeat center center;
                }

                &.img {
                    background: url(../imgs/icon-img.svg) no-repeat center center;
                }
            }

            .main {
                width: calc(100% - 46px - 20px - 16px);
                margin: 0 8px;

                .title {
                    font-size: 16px;
                    color: #333333;
                    font-weight: 600;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .other {
                    margin-top: 4px;
                    font-size: 14px;
                    color: #999999;
                    font-weight: 600;
                }
            }

            .download {
                width: 20px;
                height: 20px;
                background: url(../imgs/icon-download.svg) no-repeat center center;
                cursor: pointer;
            }
        }
    }
}
</style>
